var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"item-id":_vm.itemId,"request-status":_vm.requestStatus},on:{"reload":function($event){return _vm.$emit('reload', $event)}}},[_c('div',{ref:"chartdiv",staticClass:"gauge-chart"})])}
var staticRenderFns = []

export { render, staticRenderFns }